import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { SchedulingPortals } from 'types/Appointment';
import { Warehouse } from 'types/Warehouse';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

type WarehouseSearchResponse = {
  warehouses: Warehouse[];
};

export async function getWarehousesSearch(
  requestSource: string,
  source: SchedulingPortals,
  integrationID: number = 0
): Promise<Result<WarehouseSearchResponse, ApiError>> {
  try {
    const url = `/warehouses/external?source=${encodeURIComponent(source)}&requestSource=${encodeURIComponent(requestSource)}&integrationID=${integrationID}`;
    const { data } = await axios.get<WarehouseSearchResponse>(url);

    return ok(data);
  } catch (error) {
    captureException(error, { functionName: 'getWarehousesSearch' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to search warehouses' });
    }

    return err({
      message: error.response?.data.message || 'Failed to search warehouses',
    });
  }
}
